import ResyRewardsFAQs from './ResyRewardsFAQs';

export default ResyRewardsFAQs;
